var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    stroke: "#6C6859",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 0.75C13.3267 0.750159 14.7076 1.78601 15.8011 3.86426C16.8764 5.90797 17.5638 8.78309 17.5638 12C17.5638 15.2169 16.8764 18.092 15.8011 20.1357C14.7076 22.214 13.3267 23.2498 12.0003 23.25C10.6738 23.25 9.29216 22.2142 8.19855 20.1357C7.1233 18.092 6.43585 15.2168 6.43585 12C6.43585 8.78317 7.1233 5.90796 8.19855 3.86426C9.29216 1.78585 10.6738 0.75 12.0003 0.75Z",
    stroke: "#6C6859",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.885254 8.47449C0.885254 8.47449 7.61754 9.47449 11.9601 9.47449C16.3028 9.47449 23.035 8.47449 23.035 8.47449",
    stroke: "#6C6859",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.885254 15.5255C0.885254 15.5255 7.61754 16.5255 11.9601 16.5255C16.3028 16.5255 23.035 15.5255 23.035 15.5255",
    stroke: "#6C6859",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/LanguageIcon.e49c2d612a6fa8201c44f7b65a50004d.svg";
export { ForwardRef as ReactComponent };